import React from "react";
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getFullName, getInitials } from "@/lib/userUtils";
import { resolveAvatarUrl } from "@/lib/avatarApi";
import { cn } from "@/lib/utils";

/**
 * Social-plane user avatar. Uses social `avatar_url` (never org member_avatar_url).
 * Pass `to` (e.g. `/u/handle`) to make the avatar a profile link.
 */
export default function SocialUserAvatar({
  user,
  avatarUrl,
  displayName,
  className,
  fallbackClassName,
  to = null,
}) {
  const src = resolveAvatarUrl(
    avatarUrl ?? user?.avatar_url ?? user?.avatarUrl ?? null
  );
  const label =
    displayName ||
    user?.display_name ||
    getFullName(user) ||
    user?.username ||
    "User";
  const initials =
    getInitials(
      user?.display_name
        ? { first_name: user.display_name, last_name: "" }
        : user
    ) ||
    (typeof label === "string" ? label.slice(0, 2).toUpperCase() : "?");

  const avatar = (
    <Avatar className={cn(className)}>
      {src ? <AvatarImage src={src} alt={label} /> : null}
      <AvatarFallback className={cn(fallbackClassName)}>
        {initials || "?"}
      </AvatarFallback>
    </Avatar>
  );

  if (!to) return avatar;

  return (
    <Link
      to={to}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex shrink-0 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label={label}
    >
      {avatar}
    </Link>
  );
}
